import {
	ChangeDetectionStrategy,
	Component,
	input,
	linkedSignal,
	OnInit,
	output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
	MatButtonToggleChange,
	MatButtonToggleModule,
} from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IChecklistOption } from '@app/domain/types';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'entity-checklist-item',
	imports: [
		MatCardModule,
		MatButtonToggleModule,
		NgxTolgeeModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		MatInputModule,
		FormsModule,
	],
	templateUrl: './entity-checklist-item.component.html',
	styleUrl: './entity-checklist-item.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityChecklistItemComponent implements OnInit {
	checklistItem = input<IChecklistOption>();
	index = input<number>();

	checklistChanged = output<[string, number]>();
	checklistComment = new FormControl<string>('');
	openComment = linkedSignal({
		source: this.checklistItem,
		computation: () =>
			this.checklistItem()?.answer === false || this.checklistItem()?.comment
				? true
				: false,
	});

	ngOnInit() {
		if (this.checklistItem()) {
			this.checklistComment.setValue(this.checklistItem().comment || null);
		}
	}

	updateAnswer(event: MatButtonToggleChange) {
		const answer: boolean = event.value as boolean;
		if (!answer) {
			this.openComment.set(true);
		}
		if (answer === true && !this.checklistComment.value) {
			this.openComment.set(false);
		}
		const template = { ...this.checklistItem(), answer: answer };
		this.checklistChanged.emit([JSON.stringify(template), this.index()]);
	}

	updateComment() {
		const option = { ...this.checklistItem(), comment: this.checklistComment.value };
		this.checklistChanged.emit([JSON.stringify(option), this.index()]);
	}
}
